import BaseModel from '../../../../base/base_model';
import {FABRIC} from './fabric_hybrid_consts';


/**
 *
 */
class FabricModel extends BaseModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FabricModel';


    /**
     * @property
     * @type {string}
     * @private
     */

    _ev = null;

    createEvName(name){
        this._ev = {[FABRIC.EV_NAME]: name};
    }

    addEvKeyVal(key, val){
        this._ev = Object.assign(this._ev, {[FABRIC.START_WITH + key] : val});
        return this.getEv();
    }

    getEv(){
        return this._ev;
    }
}

export default FabricModel;